import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import { device } from '~/utils';

@withI18next()
class CopyAttributionLink extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showCopySuccess: false,
    };
  }

  handleCopy = () => {
    const { t, photo } = this.props;
    const { nickname } = photo.creator;
    this.setState({ showCopySuccess: true });
    const text = t(Config.getPrefixContent('image_by_text'), {
      serviceLink: Config.getSiteURL(),
      imageLink: window.location.href,
      creatorName: nickname,
    });
    if (window.navigator && window.navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      device.copyToClipboard(text);
    }
  };

  render() {
    const { t, photo } = this.props;
    const { nickname } = photo.creator;

    return (
      <div className="copy-attribution">
        <div
          dangerouslySetInnerHTML={{
            __html: t(Config.getPrefixContent('image_by_text'), {
              serviceLink: Config.getSiteURL(),
              imageLink: process.browser && window.location.href,
              creatorName: nickname,
            }),
          }}
        />
        <button
          className={`btn btn-ac-primary-outline btn-${Config.serviceType} btn-copy`}
          onClick={this.handleCopy}
        >
          {this.state.showCopySuccess && (
            <FontAwesomeIcon
              icon={faCheck}
              className="icon-check"
              style={{ width: '1em' }}
            />
          )}
          {t('copy')}
        </button>
        <style jsx global>
          {`
            .copy-attribution {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 7px;
              margin-top: 7px;
              background: #f2f3f4;
              border-radius: 2px;
              color: #1b2833;
            }
            .copy-attribution a {
              color: #1b2833;
              text-decoration: underline;
            }
            .copy-attribution .btn-copy {
              margin-left: 28px;
              width: 100px;
            }
            .copy-attribution .icon-check {
              margin-right: 7px;
            }
          `}
        </style>
      </div>
    );
  }
}

export default CopyAttributionLink;
